// Libraries
import { Grid } from "@mui/material";

// Components
import DesiredVehicleSection from "./DesiredVehicleSection";
import SectionDivider from "../../SectionDivider";
import TradeVehicleSection from "./TradeVehicleSection";

export default function DesiredTradeVehicleTab() {
	return (
		<Grid className="!w-full">
			<DesiredVehicleSection />
			<SectionDivider />
			<TradeVehicleSection />
		</Grid>
	);
}
